import { Camera, HardDrive, Video, BookOpen } from 'lucide-react';
import type { Tool } from '@/registry/types';
import { ScreenCapture } from './ScreenCapture';
import { StorageInspector } from './StorageInspector';
import { ScreenRecorder } from './ScreenRecorder';
import { ReadingMode } from './ReadingMode';

export const browserTools: Tool[] = [
  {
    id: 'screen-recorder',
    name: 'Screen recorder',
    category: 'browser',
    description: 'Record screen, window, or tab — with system audio and microphone.',
    keywords: ['screen', 'record', 'video', 'webm', 'demo'],
    icon: Video,
    component: ScreenRecorder,
    featured: true,
    badge: 'new',
    inBrowser: true,
  },
  {
    id: 'screen-capture',
    name: 'Screen capture',
    category: 'browser',
    description: 'Take screenshots of your screen, window, or browser tab.',
    keywords: ['screenshot', 'screen', 'capture'],
    icon: Camera,
    component: ScreenCapture,
    inBrowser: true,
  },
  {
    id: 'reading-mode',
    name: 'Reading mode',
    category: 'browser',
    description: 'Strip clutter from a web page or HTML and render the article cleanly.',
    keywords: ['reader', 'reading', 'reader mode', 'distraction', 'clean', 'article'],
    icon: BookOpen,
    component: ReadingMode,
    badge: 'new',
    inBrowser: true,
  },
  {
    id: 'storage-inspector',
    name: 'Storage inspector',
    category: 'browser',
    description: 'Inspect and clear localStorage and sessionStorage.',
    keywords: ['localstorage', 'storage', 'cookies', 'browser', 'inspect'],
    icon: HardDrive,
    component: StorageInspector,
    inBrowser: true,
  },
];
